module.exports = __webpack_public_path__ + "media/images/homes/fast_staff2x-010de5d1d7d018c5b7b7605405807689.png";